// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3ku6E","img":"img___8jedB","name":"name___ROfA0"};